import { useMemo, useRef, useState } from 'react';
import { enableDividerButtonYn } from '../../util/notes';
export function useInitializeDividerButtonContext() {
    const [isEnabled, setIsEnabled] = useState(true);
    const selectionForDivider = useRef((ctx, selection) => {
        const shouldBeEnabled = enableDividerButtonYn(ctx, selection);
        setIsEnabled(shouldBeEnabled);
    });
    return useMemo(() => ({
        selectionForDivider: selectionForDivider.current,
        isEnabled,
    }), [selectionForDivider, isEnabled]);
}
//# sourceMappingURL=use_initialize_divider_button_context.js.map